import QuestionPreviewBox from "../../../components/shared/QuestionPreviewBox";
import sendIcon from "../../../assets/icons/send-icon.png";

const MAX_ANSWER_LENGTH = 500;

interface QuestionFormProps {
  title: string;
  answer: string;
  setAnswer: (value: string) => void;
  isSubmitting: boolean;
  onSubmit: () => void;
}

const QuestionForm = ({
  title,
  answer,
  setAnswer,
  isSubmitting,
  onSubmit,
}: QuestionFormProps) => {
  return (
    <>
      <div className="question-box-wrapper">
        <QuestionPreviewBox title={title}>
          <textarea
            className="answer-textarea"
            placeholder="כאן מקלידים את התגובה שלך..."
            value={answer}
            onChange={(e) =>
              setAnswer(e.target.value.slice(0, MAX_ANSWER_LENGTH))
            }
            maxLength={MAX_ANSWER_LENGTH}
            disabled={isSubmitting}
          />
        </QuestionPreviewBox>
      </div>

      <button
        type="button"
        className="send-button"
        onClick={onSubmit}
        disabled={isSubmitting || !answer.trim()}
      >
        שליחה
        <img
          src={sendIcon}
          alt=""
          className="send-icon"
          width={15}
          height={15}
        />
      </button>
    </>
  );
};

export default QuestionForm;
